import React from 'react';
import { useQuery } from 'react-query';
import { gql } from '@apollo/client';
import { apolloClient } from 'src/graphql/client';
import { useStateSelector } from 'src/redux';
import useActionsApp from 'src/redux/actionHooks/useActionsApp';

const HEALTH_CHECK = gql`
  {
    __typename
  }
`;

const checkServerAvailability = () =>
  apolloClient.query({
    query: HEALTH_CHECK,
    fetchPolicy: 'network-only',
  });

const MaintenanceModeRecovery: React.FC = () => {
  const isMaintenanceMode = useStateSelector(({ app }) => app.isMaintenanceMode);
  const { setMaintenanceMode } = useActionsApp();

  useQuery('maintenance-mode-check', checkServerAvailability, {
    enabled: isMaintenanceMode,
    onSuccess: () => {
      setMaintenanceMode(false);
    },
    refetchInterval: 1000 * 5,
  });

  return null;
};

export default MaintenanceModeRecovery;
